import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../api';
import { FaUser, FaEnvelope, FaLock } from 'react-icons/fa';
import { toast } from 'react-toastify';

const SetupAdmin = () => {
  const [formData, setFormData] = useState({
    title: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }
    if (formData.password.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }
    setIsLoading(true);
    try {
      await authAPI.createAdmin({
        title: formData.title,
        email: formData.email,
        password: formData.password,
      });
      toast.success('Admin account created successfully!');
      navigate('/login');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to create admin account');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <img src="/littleFeetlogo.webp" alt="Little Feet Homes" className="auth-logo" />
          <h1 className="auth-title">Create Admin Account</h1>
          <p className="auth-subtitle">Set up your administrator account</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label required">
              <FaUser style={{ display: 'inline', marginRight: '0.5rem' }} />
              Home/Organization Title
            </label>
            <input type="text" name="title" className="form-input" value={formData.title} onChange={handleChange} placeholder="E.g., Little Feet Homes" required />
          </div>
          <div className="form-group">
            <label className="form-label required">
              <FaEnvelope style={{ display: 'inline', marginRight: '0.5rem' }} />
              Email Address
            </label>
            <input type="email" name="email" className="form-input" value={formData.email} onChange={handleChange} placeholder="admin@example.com" required />
          </div>
          <div className="form-group">
            <label className="form-label required">
              <FaLock style={{ display: 'inline', marginRight: '0.5rem' }} />
              Password
            </label>
            <input type="password" name="password" className="form-input" value={formData.password} onChange={handleChange} placeholder="Min 6 characters" required />
          </div>
          <div className="form-group">
            <label className="form-label required">
              <FaLock style={{ display: 'inline', marginRight: '0.5rem' }} />
              Confirm Password
            </label>
            <input type="password" name="confirmPassword" className="form-input" value={formData.confirmPassword} onChange={handleChange} placeholder="Confirm password" required />
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%', marginTop: '1rem' }} disabled={isLoading}>
            {isLoading ? 'Creating Account...' : 'Create Admin Account'}
          </button>
          <p style={{ textAlign: 'center', marginTop: '1.5rem', color: 'var(--text-light)' }}>
            Already have an account?{' '}
            <a href="/login" style={{ color: 'var(--primary)', textDecoration: 'none', fontWeight: 600 }}>
              Sign In
            </a>
          </p>
        </form>
      </div>
    </div>
  );
};

export default SetupAdmin;
